<template>
  <div class="d-flex justify-content-around flex-column flex-md-row flex-lg-row border-bottom pb-2">
    <paso v-for="paso in pasos" class="paso"
    :id="paso.id"
    :nombre="paso.nombre"
    :activo="paso.id==pasoActivo"
    :key="paso.key"/>
  </div>
</template>

<script>
  import Paso from './Paso';
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        pasoActivo: 'pasos/getPasoActivo',
        pasos: 'pasos/getData'
      })
    },
    components: {
      paso: Paso
    }
  }
</script>

<style lang="sass" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Pasos.vue